export default __webpack_public_path__ + "static/logo-cobrand-weddingduo-eadd95e195cc9f57fff86df0d4211c14.png";